import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { forkJoin, Observable, of } from 'rxjs';
import { AppConfigService } from 'app-config';
import { filter, map, take, tap } from 'rxjs/operators';
import { GetUserPermissions } from '@modules/store/user-store/actions';
import { getUserState$ } from '@modules/store/user-store/selectors';
import { CapHeaderViewPermissions, CapHeaderUserInfoData, CapHeaderService } from '@cap/cap-ui';
import { Router } from '@angular/router';

@Injectable({
	providedIn: 'root'
})
export class PtImageMappingService {
	API_URL = AppConfigService.settings.apiServer.apiUrl;
	constructor(private http: HttpClient, private router: Router, private capHeaderService:CapHeaderService) {
	}

	/****************** SPECIMENT SERVICES :BEGIN *******************/
	// FOR MAILING SEARCH


	mailingSearch = (mailingID): Observable<any> => {
		return this.http?.get(`${this.API_URL}/mailing/${mailingID}`);
	}

	// FOR MAILING SERCH RESULT.
	mailingSearchResult = (mailingID): Observable<any> => {
		return this.http?.get(`${this.API_URL}/mailing/${mailingID}/images`);
	}

	// FOR SPECIMEN MAILING RESULT.
	specimenMailingData = (mailingID, slug): Observable<any> => {
		return this.http?.get(`${this.API_URL}/mailing/${mailingID}/${slug}`);
	}

	// FOR MAILING YEARS RESULT.
	getMailingYears(): Observable<any> {
		return this.http?.get(`${this.API_URL}/availableYears`);
	}

	// FOR MAPPED IMAGES RESULT.
	getMappedImages = (year):Observable<any> => {
		return this.http?.get(`${this.API_URL}/year/${year}/mailings`);
	}

	/****************** ADD IMAGE DAILOG BOX SERVICES :BEGIN *******************/
	// FOR IMAGE TPYE RESULT.
	getImageType = () => {
		return this.http?.get(`${this.API_URL}/imageTypes`);
	}

	// FOR CATEGORY RESULT.
	getCategory = (imagetype) => {
		return this.http?.get(`${this.API_URL}/documentType/${imagetype}/imageCatogeries`);
	}

	// FOR CATEGORY.
	getCategoryFromSubtype = (subtype) => {
		return this.http?.get(`${this.API_URL}/categoryType/${subtype}/imageCategory`);
	}

	// FOR IMAGE SUB TYPE RESULT.
	getImageSubType = (categoryType) => {
		return this.http?.get(`${this.API_URL}/categoryType/${categoryType}/imageSubTypes`);
	}

	// FOR MEGNIFICATION RESULT.
	getMegnification = () => {
		return this.http?.get(`${this.API_URL}/magnification`);
	}

	// FOR MEGNIFICATION SEQ #
	getMegnificationSequ = (mailingCode, specimenCode) => {
		return this.http?.get(`${this.API_URL}/mailing/${mailingCode}/mailingSequenceNo?specimen=${specimenCode}`);
	}

	// FOR SAVE, ADD, UPDATE, APPROVE.
	saveUpdateApproveImage = (formdata, url):Observable<any> => {
		return this.http?.post<any>(`${this.API_URL}/${url}`, formdata);
	}

	// FOR UPLOAD ON S3 BUCKET.
	uploadImageToS3 = (url, file) => {
		const headerOptions = {
			headers: new HttpHeaders({
				'Content-Type': file.type,
				'x-amz-acl': 'bucket-owner-full-control'
			})
		};

		return this.http?.put(`${url}`, file, headerOptions);
	}

	// FOR DELETE IMAGE
	deleteImage = (data):Observable<any> => {
		const options = {
			headers: new HttpHeaders({
				'Content-Type': 'application/json',
			}),
			body: data
		};
		return this.http?.delete(`${this.API_URL}/deleteImageData`, options);
	}

	// FOR VIEW LOG IMAGE.
	viewImageLog = (mailing, specimen):Observable<any> => {
	return this.http?.get(`${this.API_URL}/mailing/${mailing}/log?specimen=${specimen}`);
	}

	// FOR GET COPY DATA LIST
	getSCopyDataList = (mailingiD) => {
		return this.http?.get(`${this.API_URL}/mailing/${mailingiD}/specimen`);
	}

	// FOR VALIDATE COPY IMAGE.
	validateCopyImage = (mailingID, requestBody) => {
		return this.http?.post(`${this.API_URL}/validateCopyImage/${mailingID}`, requestBody);
	}
	/****************** ADD IMAGE DAILOG BOX SERVICES :END *******************/
	/****************** SPECIMENT SERVICES :END *******************/

	/****************** CASE BASE SERVICES :BEGIN *******************/

	// FOR CASE IMAGE MAPPING
	caseImageMapping = (anatomicID):Observable<any> => {
		return this.http?.get(`${this.API_URL}/site/${anatomicID}/images`);
	}

	// FOR SLIDE TYPE DATA.
	getSlideTypeData = ():Observable<any> => {
		return this.http?.get(`${this.API_URL}/slideTypes`);
	}

	// FOR SLIDE TYPE CASE LIST.
	getSlideTypeCaseList = (siteID, slideType):Observable<any> => {
		return this.http?.get(`${this.API_URL}/site/${siteID}/program/NGC/slideType/${slideType}/cases`);
	}

	// FOR ANATOMIC SITE.
	getAnatomicSite = ():Observable<any> => {
		return this.http?.get(`${this.API_URL}/anatomicSites`);
	}

	// FOR CASE MAILING MAPPED IMAGE.
	caseMailMappingImage = (mailingID):Observable<any> => {
		return this.http?.get(`${this.API_URL}/case/${mailingID}`);
	}

	// FOR PRIMARY DIAGNOSIS.
	populatePrimaryDiagnosis = (anatomicID):Observable<any> => {
		return this.http?.get(`${this.API_URL}/site/${anatomicID}/primaryDiagnosis`);
	}

	// FOR CASE DROP DOWN.
	populateCaseDropDown = (diagnosisID):Observable<any> => {
		return this.http?.get(`${this.API_URL}/primaryDiagnosis/${diagnosisID}/cases`);
	}

	// FOR CASE IMAGE NAME.
	getCaseImageName = (caseID):Observable<any> => {
		return this.http?.get(`${this.API_URL}/case/${caseID}/images`);
	}

	// FOR PRIMARY IMAGE NAME.
	getPrimaryBasedImageName = (anatomicID, primaryID):Observable<any> => {
		return this.http?.get(`${this.API_URL}/site/${anatomicID}/primaryDiagnosis/${primaryID}/images`);
	}

	// FOR CASE STATUS.
	getCaseStatus = (caseID):Observable<any> => {
		return this.http?.get(`${this.API_URL}/case/${caseID}/status`);
	}

	// FOR ANATOMIC SITE SEQ #
	getAnatomicSiteSequence = (anatomicCode, diagnosisCode):Observable<any> => {
		return this.http?.get(`${this.API_URL}/site/${anatomicCode}/diagnosis/${diagnosisCode}/diagnosisSequenceNo`);
	}

	// FOR CASE NUMBER SEQ #
	getCaseNumberSequence = (caseID):Observable<any> => {
		return this.http?.get(`${this.API_URL}/case/${caseID}/caseSequenceNo`);
	}

	// FOR CASE ADD IAMGE.
	saveCaseAddImage = (url, data):Observable<any> => {
		return this.http?.post(`${this.API_URL}/case/${url}`, data);
	}

	// FOR SEARCH IMAGE NAME.
	getSearchByImageName = (name) => {
		return this.http?.get(`${this.API_URL}/case/name/${name}/images`);
	}

	// FOR ANATOMIC SITE LOGS.
	getAnatomicSiteLogs = (siteCode, dCode):Observable<any> => {
		return this.http?.get(`${this.API_URL}/site/${siteCode}/diagnosis/${dCode}/log`);
	}

	// FOR CASE NUMBER LOGS.
	getCaseNumberLogs = (caseID):Observable<any> => {
		return this.http?.get(`${this.API_URL}/case/${caseID}/log`);
	}

	// FOR DATE IMAGE CASE.
	deleteCaseData = (data):Observable<any> => {
		const options = {
			headers: new HttpHeaders({
				'Content-Type': 'application/json',
			}),
			body: data
		};
		return this.http?.delete(`${this.API_URL}/case/deleteImageData`, options);
	}

	// FOR ANATOMIC SITE LIST.
	getAnatomicSiteList = ():Observable<any> => {
		return this.http?.get(`${this.API_URL}/anatomicSitesList`);
	}

	// FOR ANATOMIC SITE COPT IMAGE .
	getAnatomicSiteCopyImages = (anatomicID, primaryID):Observable<any> => {
		return this.http?.get(`${this.API_URL}/site/${anatomicID}/primaryDiagnosis/${primaryID}/copy/images`);
	}

	// FOR CASE NUMBER IMAGE.
	getCaseNumberCopyImage = (caseNumberID):Observable<any> => {
		return this.http?.get(`${this.API_URL}/case/${caseNumberID}/copy/images`);
	}

	// FOR CASE IMAGE COPY IMAGE VALIDATION.
	caseValidateCopyImage = (data):Observable<any> => {
		return this.http?.post(`${this.API_URL}/case/validateCopyImage`, data);
	}

	// FOR EXPORT CASE LIST.
	exportCaseList = (anatomicCode, primaryDiagnosis):Observable<any> => {
		return this.http?.get(`${this.API_URL}/case/site/${anatomicCode}/primaryDiagnosis/${primaryDiagnosis}/export`);
	}
	/****************** CASE BASE SERVICES :END *******************/


	//For CombineCALL
	getAllMailAccessAnatomicCall = (year,store$) => {
		return forkJoin([
			this.getMappedImages(year),this.getAnatomicSite(),of(store$.dispatch(new GetUserPermissions()))
		]).pipe(
			map(([mappedImageRes,anatomicRes,accessRes]) => {
					store$.select(getUserState$).pipe(take(1)).subscribe( (userState:any) => {
						const viewPermissions = userState.elssHeaderItemViewPermissions as CapHeaderViewPermissions[];
						const capHeaderUserInfoData: CapHeaderUserInfoData = {
							...userState,
							viewPermissions
						};
						this.capHeaderService.setUserInfo(capHeaderUserInfoData);
						if(!userState.isCAPStaff && !userState.isCommitteeMember){
							this.router.navigateByUrl('unauthorized');
						}
					});
					return [accessRes,mappedImageRes,anatomicRes];
				 //}
			})
		);
	}

	waitForUserInformationToLoad$(store$): Observable<boolean> {
        return store$.select(getUserState$).pipe(
            filter(
                (userState:any) =>
                    !!userState &&
                    !!userState.userMemberId &&
                    !!userState.loaded
            ),
            tap( function (userState:any) {

                const viewPermissions = userState.elssHeaderItemViewPermissions as CapHeaderViewPermissions[];
                const capHeaderUserInfoData: CapHeaderUserInfoData = {
                    ...userState,
                    viewPermissions
                };
                this.capHeaderService.setUserInfo(capHeaderUserInfoData);
                if(!userState.isCAPStaff && !userState.isCommitteeMember){
                    this.router.navigateByUrl('unauthorized');
                }
            }),
            map(() => true)
        );
    }
}
